module.exports = __webpack_public_path__ + "static/cap1-240ba19eae7d8037792fa08d13faa36e.jpg";